import "./HeroBlock.css";

const HeroBlock = () => {
  return (
    <section className="hero-block">
      <h1>Intelligent Queue Insights</h1>
      <p>
        Monitor demand, predict congestion, and optimize service flow using
        real-time analytics.
      </p>
    </section>
  );
};

export default HeroBlock;
